import script from "./WorkflowHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkflowHistory.vue?vue&type=script&setup=true&lang=js"

import "./WorkflowHistory.vue?vue&type=style&index=0&id=7bf83c3d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bf83c3d"]])

export default __exports__